import React from 'react';
import { Stack, Text } from 'rsuite';
import { FormModelPerson } from 'src/types/person';
import { ROLES_INFO } from './types';

interface PersonDataProps {
  personDetails: FormModelPerson;
  role: string;
  number: number;
}

export const PersonData = ({
  personDetails,
  role,
  number,
}: PersonDataProps) => {
  return (
    <Stack
      direction="column"
      alignItems="flex-start"
    >
      <h3>
        {role} {ROLES_INFO.OWNER === role && number && ` #${number}`}
      </h3>
      <Text
        as="h5"
        className="text-bold"
      >
        First Name
      </Text>
      <Text className="mb-4">{personDetails?.firstName}</Text>
      <Text
        as="h5"
        className="text-bold"
      >
        Last Name
      </Text>
      <Text className="mb-4">{personDetails?.lastName}</Text>
      <Text
        as="h5"
        className="text-bold"
      >
        Company Name
      </Text>
      <Text className="mb-4">{personDetails?.companyName}</Text>
      <Text
        as="h5"
        className="text-bold"
      >
        Phone Number
      </Text>
      <Text className="mb-4">{personDetails?.phone}</Text>
      <Text
        as="h5"
        className="text-bold"
      >
        Email
      </Text>
      <Text className="mb-4">{personDetails?.email}</Text>
      <Text
        as="h5"
        className="text-bold"
      >
        Mailing Address
      </Text>
      <Text className="mb-4">{personDetails?.mailingAddress}</Text>
      {personDetails.completePhysicalAddress && (
        <>
          <Text
            as="h5"
            className="text-bold"
          >
            Physical Address
          </Text>
          <Text className="mb-4">
            {personDetails?.completePhysicalAddress?.value}
          </Text>
        </>
      )}
    </Stack>
  );
};
